import { validateCpf } from '@/shared/utils';
import { removeFormatRegisterNumber } from '@/shared/utils/remove-format-register-number';

/**
 * Normaliza o documento do campo CPF/CAEPF. Usa o normalizador canônico
 * (preserva letras — CNPJ pode ser alfanumérico); CPF/CAEPF continuam sendo
 * validados como numéricos puros abaixo.
 */
export function getCleanCpfCaepf(value: string): string {
  return removeFormatRegisterNumber(value);
}

/** CAEPF: 14 dígitos NUMÉRICOS. Um CNPJ alfanumérico (letras) NÃO é CAEPF. */
export function isCaepfDigits(clean: string): boolean {
  return /^\d{14}$/.test(clean);
}

export function isValidCpfOrCaepf(value: string): boolean {
  const clean = getCleanCpfCaepf(value);

  if (clean.length === 11) {
    return validateCpf(clean);
  }

  return isCaepfDigits(clean);
}

export function getCpfCaepfValidationError(value: string): string | undefined {
  const clean = getCleanCpfCaepf(value);

  if (!clean) {
    return 'CPF/CAEPF é obrigatório';
  }

  if (clean.length === 11) {
    return validateCpf(clean) ? undefined : 'CPF inválido';
  }

  if (isCaepfDigits(clean)) {
    return undefined;
  }

  return 'CPF/CAEPF deve conter 11 ou 14 dígitos';
}
